module.exports = __webpack_public_path__ + "static/media/icon_percent.05f7cd85.svg";